import './SelectedCases.scss'
import './SelectedIntro.scss'
import './SelectedIntermezzo.scss'
import { useWindowSize } from '@uidotdev/usehooks'
import type { MouseEvent } from 'react'
import React from 'react'
import { StructuredText } from 'react-datocms'
import { Link, useLocation, useNavigate } from 'react-router'
import { DatoImage } from '#src/components/image/DatoImage.js'
import { EagerDatoImage } from '#src/components/image/EagerDatoImage.js'
import { VimeoPlayer } from '#src/components/VimeoPlayer.js'
import { languageService } from '#src/languageService.js'
import type { SelectedCase } from '#src/pages/selected-cases/selectedCasesData.js'

interface SelectedCaseProps {
  selectedCase: SelectedCase
}

export default function SelectedCaseComponent(props: SelectedCaseProps) {
  const { selectedCase } = props
  const windowSize = useWindowSize()
  const innerWidth = windowSize.width || 0
  const navigate = useNavigate()
  const { pathname } = useLocation()
  // localized home (cases live on the home page), e.g. /sv on Swedish pages
  const home = languageService.localizePath('/', languageService.languageFromPath(pathname))

  function goBack(e: MouseEvent) {
    e.preventDefault() // the href is a fallback (open-in-new-tab); in-page we go back
    if ((globalThis.history?.length || 0) > 2) {
      void navigate(-1)
    } else {
      void navigate(home, { replace: true })
    }
  }

  const image =
    innerWidth > 831
      ? selectedCase.introImageDesktop.responsiveImage
      : selectedCase.introImageMobile.responsiveImage

  return (
    <section className="selected">
      <div className="selected__intro">
        <h2 className="selected__heading">{selectedCase.name}</h2>
        <div className="selected__text-container">
          <StructuredText data={selectedCase.content} />
        </div>

        <div className="selected__lead-image">
          <EagerDatoImage
            className="selected__lead-image"
            responsiveImage={image}
            sizes={['(max-width: 831px) 100vw', '50vw']}
          />
        </div>

        {/* {props.video && (*/}
        {/*  <video className="selected__lead-video" autoPlay={true} muted loop playsInline={true}>*/}
        {/*    <source src={props.video} type="video/mp4" />*/}
        {/*  </video>*/}
        {/* )}*/}
      </div>

      <div className="selected__intermezzo">
        {selectedCase.intermezzoImage && (
          <DatoImage
            className="selected__intermezzo-image"
            data={selectedCase.intermezzoImage.responsiveImage}
            sizes={'(max-width: 831px) 100vw, 50vw'}
            style={{ maxWidth: '100%' }}
          />
        )}
        {selectedCase.intermezzoVideo && (
          <VimeoPlayer
            video={selectedCase.intermezzoVideo}
            className="selected__intermezzo-image"
          />
        )}
        <h3 className="selected__intermezzo-title">{selectedCase.intermezzoText}</h3>
      </div>

      <div className="selected__grid">
        {selectedCase.images.map(img => (
          <img
            key={img.responsiveImage.src}
            className="selected__grid-image"
            src={img.responsiveImage.src!}
            alt={selectedCase.name}
          />
        ))}
      </div>

      <Link className="selected__navlink" to={home} onClick={goBack}>
        <button className="selected__goback-btn">
          <div className="selected__goback-btn-arrow" />
          <p className="selected__goback-btn-title">Go back</p>
        </button>
      </Link>
    </section>
  )
}
